import React, { useEffect, useState } from "react";
import { DebounceInput } from "react-debounce-input";
import ReactPaginate from "react-paginate";
import { Search, HelpCircle, CheckSquare } from "react-feather";
import { toast } from "react-toastify";
import Select from "react-select";
import { excelParams, GET, PGET, POST } from "../../../api/adminApi";
import ChangeStatus from "./ChangeStatus";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { formatNumber } from "../../../utils/utilities";
import CustomDatePicker from "../../common/CustomDatePicker";
import moment from "moment";
import { CustomSvg } from "../../../utils/CustomSvg";

function RequestFromMasters() {
  const [items, setItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [value, setValue] = useState("");
  const [currentPage, setCurrentPage] = useState(
    +localStorage.getItem("currentPageRequestFromMasters") || 0
  ); //for numeration and saving currentPage after refresh
  const [selectedUser, setSelectedUser] = useState(null);
  const [code, setCode] = useState(""); // checkCode input
  const [selectImg, setSelectImg] = useState(true);
  const [statusOptions, setStatusOptions] = useState([
    { id: 0, name: "Все" },
    { id: 1, name: "В ожидании" },
    { id: 2, name: "Одобрено" },
  ]);
  const [dateRange, setDateRange] = useState([
    new Date("2026-01-01"),
    new Date("2027-01-01"),
  ]);

  const [startDate, endDate] = dateRange;
  const [statusOpt, setStatusOpt] = useState(statusOptions[0]);
  const [modal, setModal] = useState({ show: false, user: null });
  const [changeStatusOptions, setChangeStatusOptions] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [region, setRegion] = useState({ id: 0, name: "Все регионы" });
  const [regions, setRegions] = useState(region[0]);

  const [dateRange$, setDateRange$] = useState([
    new Date("2026-01-01"),
    new Date("2027-01-01"),
  ]);
  const [startDate$, endDate$] = dateRange$;
  async function getRegions() {
    const response = await GET("/services/admin/api/region-helper/1");
    if (response?.length > 0) {
      setRegions([region, ...response]);
    }
  }

  const handleChangeRegion = (option) => {
    setRegion(option);
  };
  const selectStatus = (selectedOpt) => {
    if (statusOpt !== selectedOpt) {
      setStatusOpt(selectedOpt);
      setCurrentPageToZero();
    }
  };

  const handleSearchInput = (e) => {
    setValue(e.target.value);
    setCurrentPageToZero();
  };

  function setCurrentPageToZero() {
    setCurrentPage(0);
    localStorage.setItem("currentPageRequestFromMasters", 0);
  }

  function paginate(data) {
    setCurrentPage(data.selected); //for numeration
    localStorage.setItem("currentPageRequestFromMasters", data.selected); //for saving currentPage after refresh
  }

  async function getItems() {
    const data = await PGET(
      "/services/admin/api/request/masters-pageList",
      true,
      {
        statusId: statusOpt.id,
        page: currentPage,
        size: 15,
        search: value,
        regionId: region.id,
        dateFrom: moment(startDate$).format("YYYY-MM-DD"),
        dateTo: moment(endDate$).add(1, "day").format("YYYY-MM-DD"),
      }
    );
    setTotalCount(Math.ceil(data.headers["x-total-count"]));
    setPageCount(Math.ceil(data?.headers["x-total-count"] / 15));
    setItems(data?.data);
    setCode(!code ? data?.data[0]?.receivedCode : "");
  }

  async function handleCheckCodeInput(e) {
    e.preventDefault();
    const response = await POST(
      "/services/admin/api/request/masters/checkCode",
      { code, requestCode: selectedUser.id }
    );
    toast.info(response?.message);
    getItems().then(setCode(""));
  }
  useEffect(() => {
    getRegions();
  }, []);
  useEffect(() => {
    getItems();
  }, [statusOpt, currentPage, value, region, startDate$, endDate$]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setSelectedUser(
      (prev) =>
        items &&
        (prev
          ? items.find((item) => item.id === prev.id) === undefined
            ? items[0]
            : items.find((item) => item.id === prev.id)
          : items[0])
    );
  }, [items]);

  useEffect(() => {
    // async function getStatusHelper() {
    //   const data = await PGET("/services/admin/api/request/status-helper");
    //   if (data) {
    //     setStatusOptions([statusOptions[0], ...data.data]);
    //   }
    // }
    //
    // getStatusHelper();

    async function getChangeStatusOptions() {
      const res = await PGET(
        "/services/admin/api/request/status-helper-change"
      );
      if (res) {
        setChangeStatusOptions(res.data);
      }
    }

    getChangeStatusOptions();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  async function getProducts() {
    const data = await PGET("/services/admin/api/orders-list/", true, {
      beginCreatedOn: moment(startDate).format("DD-MM-YYYY"),
      endCreatedOn: moment(startDate).format("DD-MM-YYYY"),
    });
    if (data) {
      getItems();
    }
    console.log(data, "DATA");
  }
  function weekOwnerAgents() {
    const excelUrl =
      "https://api-club.akfacomfort.uz/services/admin/api/request/requests-download-all";
    const fileName = "reportall.xlsx";
    excelParams(excelUrl, fileName, true, {
      search: value,
      regionId: region.id,
      dateFrom: moment(startDate$).format("YYYY-MM-DD"),
      dateTo: moment(endDate$).add(1, "day").format("YYYY-MM-DD"),
    });
  }
  return (
    <div
      className="br-5 card"
      style={{ background: "#eef1ff", marginTop: "-0.4rem", height: "100vh" }}
    >
      <div
        style={{ paddingLeft: "13px" }}
        className="fz18 pl-7 d-flex align-items-center pt-7"
      >
        <h3 className="card-title align-items-start flex">
          <span className="card-label fw-bold fs-3 mb-1">Продажа</span>
          <h4
            className="!text-[#f45454] mt-[3px] ml-2"
            style={{ color: "#f62121", marginTop: "2px" }}
          >
            {totalCount}
          </h4>
        </h3>
      </div>

      <div className="px-3 pb-4 pt-2">
        <div className="mb-4 d-flex justify-content-between">
          <div className="w-100 flex flex-row">
            <div>
              <CustomDatePicker
                startDate={startDate}
                onChange={(date) => setDateRange([date, date])}
                className="datepicker-custom-input !h-[36px]"
                selectsRange={false}
              />
            </div>
            <button
              className="border-0 rounded-1 !bg-cyan-60 ml-2"
              onClick={getProducts}
              style={{ backgroundColor: "#f45454", color: "#fff" }}
            >
              Синхронизация
            </button>
          </div>
          <div className="w-100 flex flex-row">
            <div
              className="d-flex justify-content-end w-100"
              style={{ width: "150px" }}
            >
              <div style={{ width: 250 }} className="mr-2">
                <CustomDatePicker
                  startDate={startDate$}
                  endDate={endDate$}
                  onChange={(update) => {
                    setDateRange$(update);
                  }}
                  className="datepicker-custom-input"
                />
              </div>
              <div className="mr-2">
                <Select
                  name="regionId"
                  className="custom-react-select"
                  options={regions}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.id}
                  value={region}
                  style={{ height: 30 }}
                  onChange={handleChangeRegion}
                />
              </div>
              {/*<Select*/}
              {/*  className="w-30 h-100"*/}
              {/*  value={statusOpt}*/}
              {/*  getOptionLabel={(option) => option.name}*/}
              {/*  getOptionValue={(option) => option.id}*/}
              {/*  options={statusOptions}*/}
              {/*  onChange={selectStatus}*/}
              {/*/>*/}
            </div>

            <div className="position-relative w-[300px]">
              <DebounceInput
                minLength={3}
                debounceTimeout={400}
                value={value}
                onChange={handleSearchInput}
                type="text"
                className="input-search search-icon br-5 h-100 w-[300px]"
                size={24}
                placeholder="Поиск"
              />
            </div>
            <div className="d-flex ml-2" style={{ width: 200 }}>
              <button
                onClick={weekOwnerAgents}
                className="mr-0 box-shadow"
                style={{
                  backgroundColor: "#fcfcfc",
                  height: 38,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  border: "1px solid rgb(212, 211, 214)",
                  borderRadius: 5,
                  padding: "0 10px",
                }}
              >
                <CustomSvg
                  path="/icons/duotune/files/fil017.svg"
                  className="svg-icon-3 mr-2"
                />
                Скачать все
              </button>
            </div>
          </div>
        </div>

        <div className="mt-4">
          <div style={{ overflow: "auto", maxHeight: "75vh" }}>
            <table className="table p-0 table-rounded border gy-5 gs-7 rounded box-shadow br-5 align-self-start">
              <thead className="position-sticky top-0 rounded">
                <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                  <th
                    className="text-center text-white"
                    style={{
                      backgroundColor: "#E7372C",
                      fontWeight: "700",
                      borderTopLeftRadius: "8px",
                    }}
                  >
                    №
                  </th>
                  <th
                    className="text-start text-white"
                    style={{
                      backgroundColor: "#E7372C",
                      fontWeight: "700",
                      width: "160px",
                    }}
                  >
                    Время получения
                  </th>
                  <th
                    className="text-start text-white"
                    style={{
                      backgroundColor: "#E7372C",
                      fontWeight: "700",
                      width: "160px",
                    }}
                  >
                    Время продажи
                  </th>
                  {/*<th className="text-start text-white"*/}
                  {/*    style={{backgroundColor: '#E7372C', fontWeight: "700"}}>Номер запроса*/}
                  {/*</th>*/}
                  <th
                    className="text-start text-white"
                    style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                  >
                    Продавец
                  </th>
                  <th
                    className="text-start text-white"
                    style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                  >
                    Регион
                  </th>
                  <th
                    className="text-start text-white"
                    style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                  >
                    Продукт
                  </th>

                  <th
                    className="text-right text-white"
                    style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                  >
                    Упаковке
                  </th>
                  <th
                    className="text-right text-white"
                    style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                  >
                    Балл
                  </th>
                  <th
                    className="text-right text-white"
                    style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                  >
                    Продажи
                  </th>
                  {/*<th*/}
                  {/*  className="text-right text-white"*/}
                  {/*  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}*/}
                  {/*>*/}
                  {/*  Статус*/}
                  {/*</th>*/}
                  <th
                    className="text-right text-white"
                    style={{
                      backgroundColor: "#E7372C",
                      fontWeight: "700",
                      width: "130px",
                    }}
                  >
                    Общий балл
                  </th>
                  {/*<th className="text-center text-white "*/}
                  {/*    style={{backgroundColor: '#E7372C', fontWeight: "700"}}>Полученный код*/}
                  {/*</th>*/}
                  {items?.map((user, idx) => {
                    user.requestStatusId !== 2 && (
                      <th
                        className="text-center text-white "
                        style={{
                          backgroundColor: "#E7372C",
                          fontWeight: "700",
                          borderTopRightRadius: "8px",
                        }}
                      ></th>
                    );
                  })}
                </tr>
              </thead>

              <tbody style={{ overflowX: "auto" }}>
                {items?.map((user, idx) => {
                  const {
                    id,
                    receivedDate,
                    soldDate,
                    phone,
                    requestStatus,
                    requestStatusId,
                    earnedPoint,
                    receivedCode,
                    photo,
                    sellerName,
                  } = user;

                  return (
                    <tr
                      onClick={() => {
                        setSelectedUser(user);
                        setCode(receivedCode);
                      }}
                      role="button"
                      className={
                        id === selectedUser?.id
                          ? "box-shadow rowHover"
                          : "rowHover"
                      }
                      style={{
                        background: `${
                          id === selectedUser?.id
                            ? "rgba(231, 55, 44, 0.15)"
                            : "white"
                        }`,
                      }}
                      key={id}
                    >
                      <td className="text-center pointer">
                        {currentPage === 0
                          ? idx + 1
                          : // : currentPage * 10 + idx + 1} // for 10 items per page
                            // for 15 items per page
                            currentPage * 10 + idx + 1 + 5 * currentPage}
                      </td>
                      <td className="text-start">
                        {new Date(receivedDate).toLocaleString()}
                      </td>
                      <td className="text-start">
                        {new Date(soldDate).toLocaleString()}
                      </td>
                      {/*<td className="text-start">{id}</td>*/}
                      <td className="text-start">
                        <div className="d-flex">
                          {/*<img alt="img" src={photo ? "https://bo.akfacomfort.uz/" + photo : "https://th.bing.com/th/id/OIP.1V_ec2D7-sqwJoC5qZOmUQAAAA?pid=ImgDet&rs=1"} className="user-image"/>*/}
                          <div className="d-flex flex-column mr-3">
                            <span className="fw-bold mb-1">{sellerName}</span>
                            {/*<p className="fs-7 lh-1">{'+' + phone}</p>*/}
                          </div>
                        </div>
                      </td>
                      <td className="text-start">{user.regionName}</td>
                      <td className="text-start">{user.productName}</td>
                      <td className="text-right">{user.boxCount}</td>
                      <td className="text-right">{user.productPoint}</td>
                      <td className="text-right">
                        {formatNumber(user.soldCount)}
                      </td>
                      {/*<td className={`text-right w-10`}>*/}
                      {/*  <b*/}
                      {/*    style={{*/}
                      {/*      whiteSpace: "nowrap",*/}
                      {/*    }}*/}
                      {/*    className={`badge ${*/}
                      {/*      requestStatusId === 1*/}
                      {/*        ? "badge-warning"*/}
                      {/*        : requestStatusId === 2*/}
                      {/*          ? "badge-success"*/}
                      {/*          : requestStatusId === 3*/}
                      {/*            ? "badge-danger"*/}
                      {/*            : "badge-primary"*/}
                      {/*    }`}*/}
                      {/*  >*/}
                      {/*    {requestStatus}*/}
                      {/*  </b>*/}
                      {/*</td>*/}
                      <td className="text-right">
                        {formatNumber(earnedPoint)}
                      </td>
                      {/*<td className="text-center">{receivedCode}</td>*/}
                      {requestStatusId !== 2 && (
                        <td className="text-center">
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setModal({ show: true, user });
                            }}
                            className="btn btn-table box-shadow br-5"
                            style={{ backgroundColor: "#F4F4F5" }}
                          >
                            <CheckSquare color={"#5C3EBA"} size={16} />
                          </button>
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="mt-5">
            {pageCount > 1 && (
              <ReactPaginate
                forcePage={currentPage}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={pageCount}
                marginPagesDisplayed={1}
                pageRangeDisplayed={1}
                onPageChange={paginate}
                containerClassName={"pagination"}
                activeClassName={"active"}
                pageClassName={"page-item box-shadow br-5"}
              />
            )}
          </div>
        </div>

        {/*<div className="h-100">*/}
        {/*    <table*/}
        {/*        className="table px-0 py-1 table-rounded bg-white border gy-3 gs-7 background-white rounded box-shadow br-5">*/}
        {/*        <tbody>*/}
        {/*        <tr style={{borderBottom: "rgba(0, 0, 0, 0.15) 1px solid"}}>*/}
        {/*            <th>Мастер:</th>*/}
        {/*            <td className="text-end">{selectedUser?.masterName}</td>*/}
        {/*        </tr>*/}
        {/*        <tr style={{borderBottom: "rgba(0, 0, 0, 0.15) 1px solid"}}>*/}
        {/*            <th>Регион:</th>*/}
        {/*            <td className="text-end">*/}
        {/*                {selectedUser?.regionName}*/}
        {/*            </td>*/}
        {/*        </tr>*/}
        {/*        <tr>*/}
        {/*            <th>Город/Район:</th>*/}
        {/*            <td className="text-end">*/}
        {/*                {selectedUser?.cityName}*/}
        {/*            </td>*/}
        {/*        </tr>*/}
        {/*        </tbody>*/}
        {/*    </table>*/}
        {/*    {selectedUser?.requestStatusId === 4 && (*/}
        {/*        <table className="table px-0 py-1 bg-white table-rounded border gy-3 gs-7">*/}
        {/*            <tbody>*/}
        {/*            <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">*/}
        {/*                <th>Продан:</th>*/}
        {/*                <td className="text-end">*/}
        {/*                    {selectedUser?.soldMasterName}*/}
        {/*                </td>*/}
        {/*            </tr>*/}
        {/*            <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">*/}
        {/*                <th>Номер запроса:</th>*/}
        {/*                <td className="text-end">*/}
        {/*                    {selectedUser?.soldRequestId}*/}
        {/*                </td>*/}
        {/*            </tr>*/}
        {/*            </tbody>*/}
        {/*        </table>*/}
        {/*    )}*/}
        {/*    <div*/}
        {/*        className="rounded box-shadow br-5 background-white d-flex items-center justify-content-center">*/}
        {/*        <TransformWrapper>*/}
        {/*            <TransformComponent>*/}
        {/*            <img*/}
        {/*                    style={{*/}
        {/*                        width: "100%",*/}
        {/*                        maxHeight: "414px",*/}
        {/*                        minHeight: "330px",*/}
        {/*                        padding: "15px"*/}
        {/*                    }}*/}
        {/*                    src={selectedUser?.photo ? "https://bo.akfacomfort.uz/" + selectedUser?.photo : "https://th.bing.com/th/id/OIP.1V_ec2D7-sqwJoC5qZOmUQAAAA?pid=ImgDet&rs=1"}*/}
        {/*                    alt="img"*/}
        {/*                />*/}
        {/*            </TransformComponent>*/}
        {/*        </TransformWrapper>*/}
        {/*    </div>*/}
        {/*    {selectedUser?.requestStatusId === 2 ? null : (*/}
        {/*        <form*/}
        {/*            onSubmit={handleCheckCodeInput}*/}
        {/*            className="input-group my-3 rounded box-shadow br-5"*/}
        {/*        >*/}
        {/*            <input*/}
        {/*                value={code}*/}
        {/*                onChange={(e) => setCode(e.target.value)}*/}
        {/*                type="text"*/}
        {/*                className="form-control"*/}
        {/*                placeholder="Введите серийный номер"*/}
        {/*                aria-describedby="button-addon2"*/}
        {/*                disabled={true}*/}
        {/*            />*/}
        {/*            <button*/}
        {/*                className="btn btn-success"*/}
        {/*                type="submit"*/}
        {/*                id="button-addon2"*/}
        {/*            >*/}
        {/*                Проверить*/}
        {/*            </button>*/}
        {/*        </form>*/}
        {/*    )}*/}

        {/*</div>*/}
      </div>

      {modal.user && (
        <ChangeStatus
          modal={modal}
          setModal={setModal}
          getItems={getItems}
          statusOptions={changeStatusOptions}
        />
      )}
    </div>
  );
}

export default RequestFromMasters;
